import { useEffect } from 'react';
import SiteHeader from '@/components/feature/SiteHeader';
import SiteFooter from '@/components/feature/SiteFooter';
import { useScrollToHash } from '@/hooks/useScrollToHash';
import { injectBreadcrumbSchema, injectFaqSchema } from '@/utils/structuredData';
import { applyPageSeo } from '@/utils/seo';
import Hero from './components/Hero';
import StrategyQuickNav from './components/StrategyQuickNav';
import MarketScope from './components/MarketScope';
import CorePrinciples from './components/CorePrinciples';
import MarketRead from './components/MarketRead';
import EntryLogic from './components/EntryLogic';
import TradeManagement from './components/TradeManagement';
import TradingSession from './components/TradingSession';
import Directions from './components/Directions';
import ScoringScope from './components/ScoringScope';
import RecordSequence from './components/RecordSequence';
import PerformanceCurve from './components/PerformanceCurve';
import StrategyCta from './components/StrategyCta';
import StrategyFaq, { faqs } from './components/StrategyFaq';

const pageTitle = 'Gold Strategy | XAUUSD Trading Strategy | GoldEA';
const pageDescription =
  'The trading strategy behind GoldEA — how this XAUUSD Expert Advisor reads market structure, qualifies each gold setup and manages positions from entry to exit.';
const pageKeywords =
  'XAUUSD strategy, gold trading strategy, MT5 gold EA, market structure trading';

export default function GoldStrategy() {
  useScrollToHash();

  useEffect(() => {
    const removeSeo = applyPageSeo({
      title: pageTitle,
      description: pageDescription,
      keywords: pageKeywords,
      path: '/gold-strategy',
    });
    const removeBreadcrumb = injectBreadcrumbSchema('Gold Strategy', '/gold-strategy');
    const removeFaq = injectFaqSchema(faqs);
    return () => {
      removeSeo();
      removeBreadcrumb();
      removeFaq();
    };
  }, []);

  return (
    <div className="w-full min-h-screen bg-background-50">
      <SiteHeader current="gold-strategy" />
      <main>
        <Hero />
        <StrategyQuickNav />
        <MarketScope />
        <CorePrinciples />
        <MarketRead />
        <EntryLogic />
        <TradeManagement />
        <TradingSession />
        <Directions />
        <ScoringScope />
        <RecordSequence />
        <PerformanceCurve />
        <StrategyCta />
        <StrategyFaq />
      </main>
      <SiteFooter current="gold-strategy" />
    </div>
  );
}